import { WifiOff } from 'lucide-react'

// Direct import: the `@/hooks` barrel pulls in every feature module hook.
import { useOnlineStatus } from '@/hooks/use-online-status'

/**
 * Global connectivity notice. MasterHub keeps most state locally, so losing the
 * network degrades rather than breaks the app — the banner sets that
 * expectation instead of blocking the UI.
 */
export function OfflineBanner() {
  const online = useOnlineStatus()

  if (online) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-destructive text-destructive-foreground flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium"
    >
      <WifiOff className="size-4" aria-hidden />
      Você está offline. As alterações permanecem neste dispositivo até a conexão voltar.
    </div>
  )
}
